define('all/slider',['jquery'], function($) {
    'use strict';

    function slideStep($nextBox) {
        var $currentBox = $('.box.slide-in-left', parent.document.body);
        if ($currentBox.length > 0) {
			$currentBox.removeClass('slide-in-right');
            $currentBox.addClass('slide-out-left');
        } else {
            $currentBox = $('.box.slide-in-right', parent.document.body);
            if ($currentBox.length > 0) {
                $currentBox.removeClass('slide-in-right');
                $currentBox.addClass('slide-out-left');
            } else if ($nextBox.length < 1) {
                var $controller = $('.controller').filter(function() { return $(this).css('display') !== 'none';}).first();
                $nextBox = $controller.find('.box').first();
            }
        }

		// CO-13380: slide the steps to right-to-left for the new Payment Flow
        if ($nextBox !== undefined) {
            slideInRight($nextBox);
        } else {
            slideInRight($currentBox.next());
        }
    }

    function slideBack($nextBox) {
        var currentSlideClass = 'slide-in-right';
        var boxClass = '.box.';
        var currentBoxClass = boxClass + currentSlideClass;
        var $currentBox = $(currentBoxClass, parent.document.body);
        if($currentBox.length === 0){
            currentSlideClass = 'slide-in-left';
            currentBoxClass = boxClass + currentSlideClass;
            $currentBox = $(currentBoxClass, parent.document.body);
        }
        $currentBox.removeClass(currentSlideClass);
        $currentBox.addClass('slide-out-right');

        $nextBox.removeClass('slide-out-left');
        $nextBox.show();
        $nextBox.addClass('slide-in-left');
    }

    function slideInLeft($nextBox) {
        $nextBox.removeClass('slide-out-left');
        $nextBox.removeClass('slide-out-right');
        setTimeout(function() {
            $nextBox.show();
            $nextBox.addClass('slide-in-left');
        }, 100);
    }

	function slideInRight($nextBox) {
        $nextBox.removeClass('slide-out-left');
        $nextBox.removeClass('slide-out-right');
        setTimeout(function() {
            $nextBox.show();
            $nextBox.addClass('slide-in-right');
        }, 100);
    }

    function slideIcon() {
        var $activeStateIcon = $('.active.step');
        $activeStateIcon.removeClass('active');
        $activeStateIcon.addClass('done');
        $activeStateIcon.addClass('animate');

        var $nextIcon = $activeStateIcon.next();
        $nextIcon.addClass('active');
    }

    var slider = {};
    slider.slideStep = slideStep;
    slider.slideBack = slideBack;
    slider.slideIcon = slideIcon;
    return slider;
});

